module.exports = __webpack_public_path__ + "assets/rosette-modal-info.8f61bba8.svg";